import React from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import utils from '../../modules/utils.js'
import './recap_area.css'

const mapStateToProps = (state) => {
  return {
    prodotto: state.prodotto
  }
}

class RecapArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'giorno': '',
      'filiale': '',
      'ora': '',
      'indirizzo': ''
    }
  }
  componentWillMount() {
    const g_state = utils.getState();
    let indirizzo = '';
    if (g_state.dati_locali && g_state.dati_locali.filiali) {
      for (let f in g_state.dati_locali.filiali.filiali) {
        const filiale = g_state.dati_locali.filiali.filiali[f];
        if (filiale.idFiliale == g_state.id_filiale) {
          indirizzo = filiale.indirizzo + " - " + filiale.citta + " (" + filiale.provincia + ")";
        }
      }
    }
    this.setState({
      'giorno': moment(g_state.data_appuntamento).format("dddd DD MMMM YYYY"),
      'filiale': g_state.filiale,
      'ora': g_state.orario_appuntamento,
      'indirizzo': indirizzo
    });
  }
  render() {
    const isDatiPersonali = window.location.pathname === utils.getFaPath() + "/dati-personali" || window.location.pathname === utils.getFaPath() + "/dati-personali-riconosciuto";
    const recap_class = isDatiPersonali ? 'hidden' : '';

    if (this.props.visible) {
      if (this.props.prodotto != 3 && this.props.prodotto != 5) {
        return (
          <div className={"recap-area-container " + this.props.className}>
            <h2 className={"gsap-fade small-margin"}>Ecco il riepilogo del tuo appuntamento:</h2>
            <div className="recap-area">
              <div className="grid-container">
                <div className="grid-x grid-padding-x">
                  <div className="cell small-12 medium-6">
                    <div className="rebox">
                      <p className="lab">Quando sarà il tuo appuntamento:</p>
                      <p className="value">{this.state.giorno}</p>
                    </div>
                  </div>
                  <div className="cell small-12 medium-6">
                    <div className="rebox">
                      <p className="lab">Dove hai scelto:</p>
                      <p className="value">{this.state.filiale} - {this.state.ora}</p>
                      <p className="sub_value">{this.state.indirizzo}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h4 className={"gsap-fade " + recap_class}>Per confermare l'appuntamento, inserisci il tuo Codice Fiscale e prosegui</h4>
          </div>
        )
      } else if (this.props.prodotto == 5) {
        return (
          <div className="recap-AUP">
            <h2 className={"gsap-fade recap-AUP__title"}>Prestito Business</h2>
            <h4 className={"gsap-fade recap-AUP__subtitle" + recap_class}>Fino a 50.000 € per la tua attività.</h4>
          </div>
        )
      } else {
        return (
          <div className="recapC5">
            <div className="grid-container">
              <div className="grid-x grid-padding-x">
                <div className="cell medium-4 large-3">
                  <a href="https://www.compassquinto.it/"><img src="./img/quinto.jpg" alt="Logo Compass Quinto" /></a>
                </div>
                <div className="cell medium-8 large-9 text-container">
                  <h3>Il tuo finanziamento con "quelli del Quinto"</h3>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }

    return null;
  }
}

export default connect(mapStateToProps, null)(RecapArea);


// WEBPACK FOOTER //
// ./src/components/shared/recap_area.js